/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface TicketAdmission
 */
export interface TicketAdmission {
    /**
     * 
     * @type {string}
     * @memberof TicketAdmission
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof TicketAdmission
     */
    buyerName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof TicketAdmission
     */
    seat: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof TicketAdmission
     */
    checkedInAt: Date | null;
}

/**
 * Check if a given object implements the TicketAdmission interface.
 */
export function instanceOfTicketAdmission(value: object): value is TicketAdmission {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('buyerName' in value) || value['buyerName'] === undefined) return false;
    if (!('seat' in value) || value['seat'] === undefined) return false;
    if (!('checkedInAt' in value) || value['checkedInAt'] === undefined) return false;
    return true;
}

export function TicketAdmissionFromJSON(json: any): TicketAdmission {
    return TicketAdmissionFromJSONTyped(json, false);
}

export function TicketAdmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketAdmission {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'buyerName': json['buyerName'],
        'seat': ApiUserTasksGetPageParameterFromJSON(json['seat']),
        'checkedInAt': (json['checkedInAt'] == null ? null : new Date(json['checkedInAt'])),
    };
}

export function TicketAdmissionToJSON(json: any): TicketAdmission {
    return TicketAdmissionToJSONTyped(json, false);
}

export function TicketAdmissionToJSONTyped(value?: TicketAdmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'buyerName': value['buyerName'],
        'seat': ApiUserTasksGetPageParameterToJSON(value['seat']),
        'checkedInAt': value['checkedInAt'] == null ? value['checkedInAt'] : value['checkedInAt'].toISOString(),
    };
}

